module.exports = __webpack_public_path__ + "img/background-black.9e61ba43.jpg";